"use client"

import React from 'react'
import { useLanguage } from "@/components/i18n/language-provider"

export default function MediaPreview({ files, onRemove, onMove }: { files: Array<{ file: File; preview: string; progress: number }>, onRemove: (i: number) => void, onMove: (i: number, dir: -1|1) => void }) {
  const { t } = useLanguage()
  return (
    <div className="grid grid-cols-3 gap-2">
      {files.map((f, i) => (
        <div key={i} className="relative border rounded overflow-hidden group">
          <div className="h-28 w-full bg-black/5 flex items-center justify-center">
            {f.file.type.startsWith('image') ? (
              // eslint-disable-next-line @next/next/no-img-element
              <img src={f.preview} alt={f.file.name} className="object-cover h-28 w-full" />
            ) : f.file.type.startsWith('video') ? (
              // eslint-disable-next-line @next/next/no-img-element
              <video src={f.preview} className="object-cover h-28 w-full" controls autoPlay muted loop playsInline />
            ) : (
              <div className="p-2 text-xs">{f.file.name}</div>
            )}
            <div className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition">
              <button className="bg-card p-1 rounded-lg shadow border border-border/50" onClick={() => onRemove(i)}>{t("commentDelete")}</button>
            </div>
          </div>
          <div className="p-1 text-xs">
            <div className="flex items-center justify-between">
              <div className="truncate">{f.file.name}</div>
              <div className="flex gap-1">
                <button className="text-[11px] px-1" onClick={() => onMove(i, -1)} disabled={i === 0}>◀</button>
                <button className="text-[11px] px-1" onClick={() => onMove(i, 1)} disabled={i === files.length - 1}>▶</button>
              </div>
            </div>
            <div className="text-[11px] text-gray-500">{f.file.type.split('/')[0]}</div>
            <div className="h-1 bg-muted rounded mt-2">
              <div style={{ width: `${f.progress}%` }} className="h-1 bg-gradient-to-r from-cyan-500 via-indigo-600 to-blue-500 rounded" />
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
